import { createAuthClient } from 'better-auth/react';
import { magicLinkClient } from 'better-auth/client/plugins';

// In development, requests go through Vite proxy (same origin)
// In production, they go to the same origin as the frontend
export const authClient = createAuthClient({
  plugins: [magicLinkClient()],
});

export const { useSession, signOut } = authClient;

export const signInWithGoogle = async (returnTo: string = '/') => {
  const callbackURL = `${window.location.origin}/auth/callback?returnTo=${encodeURIComponent(returnTo)}`;
  return authClient.signIn.social({
    provider: 'google',
    callbackURL,
  });
};

export const updateName = async (name: string) => {
  const response = await fetch('/api/user/name', {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({ name }),
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    const message = typeof payload?.error === 'string' ? payload.error : 'Failed to update name.';
    throw new Error(message);
  }

  return response.json();
};
